import type { FC } from 'react';

import type { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition';
import { useSessionData } from '@confluence/session-data';

type EditionFeatureGateType = {
	children: (props: { isFeatureEnabled: boolean }) => JSX.Element | null;
	targetEditions: ConfluenceEdition[];
};

/**
 * The purpose of this component is to determine if a feature is enabled
 * for the current edition. This gives flexibility to consumers to
 * handle different scenarios for various editions.
 */
export const EditionFeatureGate: FC<EditionFeatureGateType> = ({ children, targetEditions }) => {
	const { edition } = useSessionData();

	return children({
		isFeatureEnabled: targetEditions.includes(edition!),
	});
};
